export default __webpack_public_path__ + "static/media/ss6.ecf87dee.jpg";